export const urlToTag = (url: string): string =>
  url
    .split('?')[0]
    .toLowerCase()
    .replace(
      /[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/g,
      'id',
    )
    .replace(/\/\d+/g, '')
    .replace(/:\d+/g, '')
    .replace(/\.com|\.co/, '')
    .replace(/www\./, '')
    .replace(/https?:\/\//, '')
    .replace(/[\/|.]/g, '-')
    .replace(/^-|-$/g, '');
